// src/FAQ.js
import React, { useEffect, useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import axios from 'axios';
import DisplayQuillContent from '../DisplayQuillContent'
import { GlobalTheme } from '../../theme';
const API_URL = 'https://aaryanholidays.in/backend/table-data/aaryaan_faq';

export default function FAQ() {
    const [faqData, setFaqData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch data from the API
        const fetchData = async () => {
            try {
                const response = await axios.get(API_URL);
                console.error('API Response:', response.data.data); // Log the response to debug
                const filteredData = response.data.data.filter(faq => faq.id !== 1); 
                  // Extract numeric values from appear_order and sort
                  const sortedData = filteredData.sort((a, b) => {
                    const orderA = parseInt(a.appear_order.replace(/<\/?p>/g, ""), 10) || 0;
                    const orderB = parseInt(b.appear_order.replace(/<\/?p>/g, ""), 10) || 0;
                    return orderA - orderB;
                });

                setFaqData(sortedData);
               
                
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <Typography align="center">Loading FAQs...</Typography>;
    }

    if (error) {
        return <Typography align="center" color="error">Error: {error}</Typography>;
    }

    return (
        <>
            <Typography id='faqHeading' variant="h4" component='h3' gutterBottom align="center">
                FAQ
            </Typography>
            {faqData.map((faq, index) => (
                <Accordion key={index} sx={{ boxShadow: 'none' }}>
                    <AccordionSummary expandIcon={<KeyboardArrowDownOutlinedIcon />} sx={{
                        '& p': {
                            fontSize: GlobalTheme.typography.pxToRem(14),
                            my: 0,
                        },
                        '& .Mui-expanded': {
                            my: 1.5
                        },

                        '& .Mui-expanded span p': {
                            fontWeight: 600
                        }
                    }}>

                        {/* Ensure the API response has a `question` field */}
                        <DisplayQuillContent content={faq.question || 'No Title'} />

                    </AccordionSummary>
                    <AccordionDetails
                        sx={{
                            '& p': {
                                fontSize: GlobalTheme.typography.pxToRem(14),
                                my: 0
                            },
                        }}>
                        <DisplayQuillContent content={faq.answer || 'No Title'} />
                    </AccordionDetails>
                </Accordion>
            ))}
        </>
    );
}